export enum HttpStatusCode {
  OK = 200,
  Created = 201,
  NoContent = 204,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  Conflict = 409,
  InternalServerError = 500,
}

export class ApiError extends Error {
  readonly statusCode: HttpStatusCode;

  /**
   * Constructs an instance of ApiError.
   * @param {Error} error - Error object.
   */
  constructor(error: Error);
  /**
   * Constructs an instance of ApiError.
   * @param {HttpStatusCode} statusCode - The HTTP status code of the error.
   * @param {string} message - A descriptive error message.
   */
  constructor(statusCode: HttpStatusCode, message: string);
  constructor(statusCodeOrError: HttpStatusCode | Error, message?: string) {
    super();
    if (typeof statusCodeOrError === 'number') {
      this.statusCode = statusCodeOrError;
      this.message = message ?? '';
    } else {
      this.cause = statusCodeOrError;
      this.statusCode = HttpStatusCode.InternalServerError; // or any default value
      this.message = statusCodeOrError.message;
    }
  }
}
